import { getWXCodeOrToRegister } from "@/utils/login.js";
import { getBranchReport } from "@/api/report.js";
import { getWeekTime } from "@/utils/datetime.js";
export default {
  data() {
    return {
      time: this.$route.query.time || getWeekTime(),
      loading: true,
      tableData: []
    };
  },
  created() {
    getWXCodeOrToRegister(this.$route, this.init);
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.xTable.connect(this.$refs.xToolbar);
    });
  },
  methods: {
    formatterPercent({ cellValue }) {
      return cellValue + "%";
    },
    init() {
      this.loading = true;
      const query = {
        weekTime: this.time,
        branchId: ""
      };
      getBranchReport(query).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          this.tableData = res.data.results.res.children;
        } else {
          this.$toast.fail("请求失败，请重试");
        }
      });
    }
  }
};
